import { render } from "./PaymentTerms.vue.ts?vue&type=template&id=61874fac&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTerms.vue?vue&type=template&id=61874fac&scoped=true&ts=true"
import script from "./PaymentTerms.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTerms.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentTerms.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTerms.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentTerms.vue.scss?vue&type=style&index=0&id=61874fac&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTerms.vue?vue&type=style&index=0&id=61874fac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61874fac"],['__file',"src/apps/merchant3/components/offers/PaymentTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61874fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61874fac', __exports__)) {
    api.reload('61874fac', __exports__)
  }
  
  module.hot.accept("./PaymentTerms.vue.ts?vue&type=template&id=61874fac&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTerms.vue?vue&type=template&id=61874fac&scoped=true&ts=true", () => {
    api.rerender('61874fac', render)
  })

}


export default __exports__